import { render, staticRenderFns } from "./platformCopywriting.vue?vue&type=template&id=7fd426d2&"
import script from "./platformCopywriting.vue?vue&type=script&lang=js&"
export * from "./platformCopywriting.vue?vue&type=script&lang=js&"
import style0 from "./platformCopywriting.vue?vue&type=style&index=0&id=7fd426d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports